import { jsx as a } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import p from "@mui/material/Radio";
import i from "styled-components";
import f from "../FormControlLabel/FormControlLabel.js";
const R = {
  root: "radioRoot",
  checked: "radioChecked",
  disabled: "radioDisabled",
  colorPrimary: "radioColorPrimary",
  colorSecondary: "radioColorSecondary"
}, h = i(f).withConfig({
  displayName: "StyledFormControlLabel"
})([
  "&.formControlLabelRoot + &.formControlLabelRoot{margin-top:8px;}"
]), y = i(p).withConfig({
  displayName: "StyledRadio"
})([
  "&&.radioRoot{padding:0px;margin:0px;svg{width:16px;height:16px;}color:",
  ";}&&.radioRoot svg:first-child{color:currentColor;}&&.radioRoot.radioChecked svg:last-child{width:16px;height:16px;color:currentColor;}&&.radioRoot:hover{background-color:transparent;color:",
  ";}&&.radioRoot:active{color:",
  ";}&&.radioRoot.radioDisabled svg:first-child,&&.radioRoot.radioDisabled svg:last-child{color:",
  ";}"
], ({ theme: o }) => o.primaryFill, ({ theme: o }) => o.primaryHover, ({ theme: o }) => o.primarySelected, ({ theme: o }) => o.secondaryDisabled), C = /* @__PURE__ */ n(({ classes: o, disabled: r = !1, FormControlLabelProps: d, fullWidth: l = !1, label: t, labelPlacement: e = "end", tooltip: s = void 0, ...c }, m) => /* @__PURE__ */ a(h, {
  ...d,
  disabled: r,
  label: t,
  tooltip: s,
  labelPlacement: e,
  control: /* @__PURE__ */ a(y, {
    ...c,
    ref: m,
    classes: {
      ...R,
      ...o
    },
    disabled: r,
    color: "default"
  }),
  fullWidth: l
}));
C.displayName = "Radio";
export {
  C as default
};
